/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Active
 *
 * 2 = Used
 *
 * 3 = Expired
 */
export enum VauchersStatusEnum {
  Active = 1,
  Used = 2,
  Expired = 3,
}
